<template>
    <div id="map" class="seller__map"></div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {store} from "../../../store/office";

    export default {
        name: "officesMap",
        store,
        computed: {
            ...mapState([
                'offices'
            ]),
        },
        methods: {
            ...mapActions([
                'getOfficeInfo',
                'initMap'
            ]),
        },
        mounted() {
            window.ymaps.ready(() => {
                this.initMap();
            });
        }
    }
</script>